module.exports = __webpack_public_path__ + "media/images/fbcalls/___recomendacao-370793dcb1ca1a3cd8a41a796db0d4be.png";